<template>
  <div class="container-novo-processo">
    <TrfHeader v-if="showTitle" pageTitle="Novo processo" />

    <form id="form-cadastro-de-processo" class="container">
      <div class="container-form-base" v-show="isFormAtivoBase">
        <ul class="modal-tabs has-text-weight-bold">
          <li>
            <a
              id="tab-processo"
              :class="{
                'is-active': abaSelecionada == 'processo' || abaSelecionada == ''
              }"
              @click="setAbaSelecionada('processo')"
              ><span>Processo &nbsp;</span>
            </a>
          </li>
          <li>
            <a
              v-if="!isProcessoComEmpresaExistente"
              id="tab-dados"
              :class="{
                'is-active': abaSelecionada == 'dados' || abaSelecionada == ''
              }"
              @click="setAbaSelecionada('dados')"
              ><span>Incluir dados do negócio &nbsp;</span>
            </a>
          </li>
        </ul>
        <div id="form-cadastro-basico" class="tab-processo" v-show="abaSelecionada == 'processo'">
          <strong>Processo de legalização</strong>
          <br/><br/>

          <TrfRadioFields
            :listaDeOpcoes="opcoesTipoDeProcesso"
            :required="true"
            class="is-fullwidth mb-4"
            id="form-cadastro-basico-tipo-processo"
            name="tipo-processo"
            titulo="Tipo de processo"
            ref="campoTipoDeProcesso"
            @update:valorSelecionado="changeTipoDeProcesso"
          />

          <TrfSelect
            v-if="isProcessoComEmpresaExistente"
            :canClear="true"
            :options="this.empresasSemLegalizacao"
            :loadingData="loadings.empresas"
            :disabled="loadings.empresas || isEdicao"
            :required="true"
            @valueSelect="setEmpresaEmLegalizacao"
            @clear="clearEmpresaEmLegalizacao"
            ref="selectEmpresaSemLegalizacao"
            placeholder="Selecione"
            label="Selecione uma empresa já existente no eContador"
            helpLabel="Este campo só deve ser preenchido se o processo for para uma empresa que já existe. Se for para abrir uma nova, marque a opção acima 'Legalização'"
            v-e2e="'select-empresas-sem-legalizacao'"
          >
            <template #erroMessage>
              <span class="campo-obrigatório">Empresa é obrigatória.</span>
            </template>
          </TrfSelect>

          <TrfProcessosFormularioBase
            @update:form-data="$event => updateModel($event)"
            ref="formularioBaseLegalizacao"
            :templates="dados.modelos"
            :loadingTemplates="loadings.modelos"
            :isProcessoComEmpresaExistente="isProcessoComEmpresaExistente"
          ></TrfProcessosFormularioBase>
          <TrfProcessosFormularioContato
            @update:form-data="$event => updateModel($event)"
            ref="formularioContatoLegalizacao"
          ></TrfProcessosFormularioContato>
        </div>
        <div id="form-cadastro-dados" class="tab-dados" v-show="abaSelecionada == 'dados'">
          <TrfEmpresaFormularioBase
            ref="processoFormEmpresa"
            :listagem-de-socios="socios"
            :showMaisAcoesSocios="showMaisAcoesSocios"
            @elegalize-iniciar-formulario-socio.capture="inicializaFormSocio"
            @elegalize-editar-formulario-socio.capture="inicializaFormSocio"
            @elegalize-excluir-formulario-socio.capture="excluiFormSocio"
            @update:form-data="$event => setEmpresa($event)"
          ></TrfEmpresaFormularioBase>
        </div>
      </div>
      <div class="container-form-socio" v-show="isFormAtivoSocio">
        <div id="form-cadastro-socio">
          <TrfFormularioBaseSocio
            ref="processoFormSocio"
            @concluir-cadastro-socio="$event => concluidoCadastroSocio($event)"
            @concluir-edicao-socio="$event => concluidoEdicaoSocio($event)"
          ></TrfFormularioBaseSocio>
        </div>
      </div>
      <div v-if="showButtons" class="buttons">
        <TrfButton @click="doSalvar()" nome="Salvar" classCor="is-primary" id="btn-form-processo-salvar"></TrfButton>
        <TrfButton @click="doCancelar()" nome="cancelar" classCor="is-white" id="btn-form-processo-cancelar"></TrfButton>
      </div>
    </form>
  </div>
</template>
<script>
import { TipoDeProcessoEnum } from '../enums/legalize.enum.js';
import { defineAsyncComponent } from 'vue';
import { routerUtils } from '../../../util/router.utils.js';
import ProcessoElegalize from './Models/processo-elegalize.model.js';
import { toastUtils } from '../../../util/toast.utils.js';
import DadosSocio from './Models/dados-socio.model.js';
import DadosEmpresa from './Models/dados-empresa.model.js';
import { empresasService } from '../../../service/empresas-service.js';

const TIPO_DE_PROCESSO_DEFAULT = TipoDeProcessoEnum.LEGALIZACAO

export default {
  name: 'ELegalizeCadastroProcesso',
  expose: ['inicializarCampos', 'doReset', 'doSalvar', 'doEditar'],
  emits: ['elegalize-configuracao-modal-socio'],
  components: {
    TrfHeader: defineAsyncComponent(() => import('../../../components/Header/index.vue')),
    TrfButton: defineAsyncComponent(() => import('../../../components/Button/index.vue')),
    TrfRadioFields: defineAsyncComponent(() => import('../../../components/RadioFields/index.vue')),
    TrfProcessosFormularioBase: defineAsyncComponent(() => import('./Components/FormularioBaseProcesso.vue')),
    TrfProcessosFormularioContato: defineAsyncComponent(() => import('./Components/FormularioContatoProcesso.vue')),
    TrfEmpresaFormularioBase: defineAsyncComponent(() => import('./Components/FormularioBaseEmpresa.vue')),
    TrfFormularioBaseSocio: defineAsyncComponent(() => import('./Components/FormularioBaseSocio.vue')),
    TrfSelect: defineAsyncComponent(() => import('../../../components/Select/index.vue'))
  },
  props: {
    showTitle: {
      type: Boolean,
      default: true
    },
    showButtons: {
      type: Boolean,
      default: true
    },
    showMaisAcoesSocios: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formAtivo: 'base',
      empresa: new DadosEmpresa(),
      socios: [],
      dados: {
        modelos: []
      },
      modelo: new ProcessoElegalize(),
      abaSelecionada: 'processo',
      loadings: {
        modelos: true,
        empresas: false
      },
      empresasSemLegalizacao: []
    };
  },
  computed: {
    isProcessoAlteracao() {
      return this.modelo.tipoDeProcessoId == TipoDeProcessoEnum.ALTERACAO;
    },
    isProcessoEncerramento() {
      return this.modelo.tipoDeProcessoId == TipoDeProcessoEnum.ENCERRAMENTO;
    },
    isProcessoComEmpresaExistente() {
      return this.isProcessoAlteracao || this.isProcessoEncerramento;
    },
    isEdicao() {
      return this.modelo.id != null;
    },
    isFormAtivoBase() {
      return this.formAtivo == 'base';
    },
    isFormAtivoSocio() {
      return this.formAtivo == 'socio';
    },
    opcoesTipoDeProcesso() {
      return [
        {
          id: 'radio-processo-legalizacao',
          label: 'Legalização',
          valor: TipoDeProcessoEnum.LEGALIZACAO,
          default: true,
          disabled: this.isEdicao
        },
        {
          id: 'radio-processo-alteracao',
          label: 'Alteração',
          valor: TipoDeProcessoEnum.ALTERACAO,
          disabled: this.isEdicao
        },
        {
          id: 'radio-processo-encerramento',
          label: 'Encerramento de empresa',
          valor: TipoDeProcessoEnum.ENCERRAMENTO,
          disabled: this.isEdicao
        }
      ];
    }
  },
  methods: {
    async importProcessoService() {
      const { processoService } = await import('../../../service/processo-service.js')
      return processoService
    },
    async importModeloService() {
      const { modeloService } = await import('../../../service/modelo-service.js')
      return modeloService
    },
    async importEmpresaService() {
      const { empresasService } = await import('../../../service/empresas-service.js');
      return empresasService;
    },
    async loadEmpresaEmLegalizacao(id) {
      if(!this.isProcessoComEmpresaExistente) return;
      if(!id) return;

      const empresasService = await this.importEmpresaService();
      const empresa = await empresasService.getById(id);
      this.empresasSemLegalizacao = [{
        label: `${empresa.data.attributes.idExterno} - ${empresa.data.attributes.nome}`,
        value: empresa.data.id
      }];
      
      await this.$nextTick();
      this.$refs.selectEmpresaSemLegalizacao.iniciarSelectComValor(empresa.data.id);
    },
    setEmpresaEmLegalizacao(id) {
      this.updateModel({
        empresaId: id
      });
    },
    clearEmpresaEmLegalizacao() {
      this.updateModel({
        empresaId: null
      });
    },
    setEmpresa(valor) {
      if (!valor) return;
      this.empresa = valor;
      this.updateModel({formularioProcesso: this.empresa})
    },
    async loadModelos() {
      try {
        this.loadings.modelos = true
        const modeloService = await this.importModeloService();
        const filtro = {
          'sort[ASC]': 'nome',
          fasesIsNull: false,
          limit: 100,
        }
        const modelos = await modeloService.listarTodos(filtro);
        this.dados.modelos = modelos
        this.loadings.modelos = false
      } catch(e) {
        this.loadings.modelos = false
        console.warn(`WARN: ${e}`)
      }
    },
    setAbaSelecionada(valor) {
      this.abaSelecionada = valor;
    },
    changeTipoDeProcesso(valor) {
      this.setTipoDeProcesso(valor);
      this.carregarEmpresasSemLegalizacao();
    },
    setTipoDeProcesso(valor) {
      this.updateModel({ tipoDeProcessoId: valor });
    },
    async carregarEmpresasSemLegalizacao() {
      if(!this.isProcessoComEmpresaExistente) return;
      if(this.empresasSemLegalizacao.length != 0) return;
      if(this.loadings.empresas) return;

      this.loadings.empresas = true;

      const empresas = await empresasService.listarSemLegalizacao();
      this.empresasSemLegalizacao = empresas.map(e => {
        return {
          value: e.id,
          label: `${e.attributes.idExterno} - ${e.attributes.nome}`
        }
      });

      this.loadings.empresas = false;
    },
    updateModel(formData) {
      this.modelo.updateDados(formData)
    },
    concluidoCadastroSocio(formData) {
      const socio = new DadosSocio();
      socio.updateDados(formData);
      this.socios.push(socio);
      this.actionCancelaSocio();
    },
    concluidoEdicaoSocio(formData) {
      const socio = new DadosSocio();
      socio.updateDados(formData);
      const index = this.socios.findIndex(s => s.id == socio.id);
      this.socios[index] = socio;
      this.actionCancelaSocio();
    },
    excluiFormSocio(event) {
      this.socios.splice(event.detail.index, 1);
    },
    isFormValido() {
      const isBaseValida = this.$refs.formularioBaseLegalizacao?.validacoes?.form;
      const isContatosValido = this.$refs.formularioContatoLegalizacao?.validacoes?.form;

      if(!this.isProcessoComEmpresaExistente) {
        const isBaseEmpresaValida = this.$refs.processoFormEmpresa?.validacoes?.form;
        return isBaseValida && isContatosValido && isBaseEmpresaValida;
      } 
      
      const isEmpresaSelecionada = !this.$refs.selectEmpresaSemLegalizacao.verificarSeInputEstaVazio();
      return isBaseValida && isContatosValido && isEmpresaSelecionada;
    },
    async doSalvar() {
      try {
        const isFormValido = this.isFormValido();
        if (!isFormValido) {
          toastUtils.dangerToast("Campo(s) obrigatório(s) e/ou inválido(s)!");
          this.$refs.formularioBaseLegalizacao.marcarValidacoes();
          this.$refs.formularioContatoLegalizacao.marcarValidacoes();
          return null;
        }
        const processoService = await this.importProcessoService();
        const response = await processoService.cadastrar(this.modelo.asRequestBody())
        toastUtils.successToast("Processo cadastrado com sucesso!")
        return response;
      } catch (e) {
        console.warn(`WARN: ${e}`)
        return null;
      }
    },
    async doEditar() {
      try {
        const isFormValido = this.isFormValido();
        if (!isFormValido) {
          toastUtils.dangerToast("Campo(s) obrigatório(s) e/ou inválido(s)!");
          this.$refs.formularioBaseLegalizacao.marcarValidacoes()
          this.$refs.formularioContatoLegalizacao.marcarValidacoes()
          return null;
        }

        const processoService = await this.importProcessoService();
        const response = await processoService.editar(this.modelo.asRequestBody(false))
        toastUtils.successToast("Processo editado com sucesso!")
        return response;
      } catch (e) {
        console.warn(`WARN: ${e}`)
        return null;
      }
    },
    doCancelar() {
      routerUtils._carregarNovaRota('/eLegalize')
    },
    doReset() {
      this.$refs.campoTipoDeProcesso._selecionarDefault();

      this.$refs.formularioBaseLegalizacao.doReset();
      this.$refs.formularioContatoLegalizacao.doReset();
      this.$refs.processoFormEmpresa.limparCampos();

      this.empresasSemLegalizacao = [];
      this.loadings.empresas = false;

      this.formAtivo = 'base';
      this.setAbaSelecionada('processo');
      this.socios = [];
      this.$emit('elegalize-configuracao-modal-socio', null);
      this.modelo = new ProcessoElegalize();
    },
    actionConfirmaSocio() {
      this.$refs.processoFormSocio.doCadastrar();
    },
    actionEditarSocio() {
      this.$refs.processoFormSocio.doEditar();
    },
    async actionCancelaSocio() {
      this.$refs.processoFormSocio.limparCampos();
      await this.$nextTick();
      this.formAtivo = 'base';
      this.$emit('elegalize-configuracao-modal-socio', null);
      await this.$nextTick();
      this.scrollToSocios();
    },
    scrollToSocios() {
      document.querySelector('#modal-processo .modal-card-body.scroll-personalizado .container-listagem-socios').scrollIntoView();
    },
    scrollToTop() {
      document.querySelector('#modal-processo .modal-card-body.scroll-personalizado').scrollTo(0,0);
    },
    inicializaFormSocio(dados) {
      const details = dados.detail;
      this.formAtivo = details.form;
      details.acaoConfirma = details.dadosEdicao ? this.actionEditarSocio : this.actionConfirmaSocio;
      details.acaoCancela = this.actionCancelaSocio;
      details.labelConfirma = details.labelConfirma;
      this.$emit('elegalize-configuracao-modal-socio', details);
      if(details.dadosEdicao) {
        this.$refs.processoFormSocio.inicializarCampos(details.dadosEdicao);
      }
      this.scrollToTop();
    },
    inicializarCampos(dados) {
      this.socios = dados.formularioProcesso.socios;
      this.modelo.updateDados(dados);

      this.$refs.formularioBaseLegalizacao.inicializarCampos(dados);
      this.$refs.formularioContatoLegalizacao.inicializarCampos(dados);
      this.$refs.processoFormEmpresa.inicializarCampos(dados.formularioProcesso);
      this.$refs.campoTipoDeProcesso._selecionarPorValor(dados.tipoDeProcessoId, TIPO_DE_PROCESSO_DEFAULT);
      this.loadEmpresaEmLegalizacao(dados.empresaId);
    }
  },
  async mounted() {
    await this.loadModelos();
  }
};
</script>
<style lang="scss" scoped>
.btn-container {
  @media screen and (max-width: 600px) {
    margin-right: 0;
  }

  @media screen and (min-width: 900px) {
    width: 150px;
    margin-right: auto;
  }
}
</style>
